/*
 * Pipeline Theme
 *
 * Use this file to add custom Javascript to Pipeline.  Keeping your custom
 * Javascript in this fill will make it easier to update Pipeline. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 *
 */

(function () {
  async function configureCustomCheckout(cart) {
    console.log("configureCustomCheckout", cart);

    // id = CartDrawer-Checkout
    const customCheckout = $('button[id="CartDrawer-Checkout"]');
    console.log("customCheckout", customCheckout);

    customCheckout.unbind("click").bind("click", async (e) => {
      e.stopPropagation();
      e.preventDefault();
      const params = new URLSearchParams();

      const currentSite = localStorage.getItem("CURRENT_SITE");
      if (currentSite) {
        console.log("currentSit added: ", currentSite);
        params.append("attributes[sponsorWebAlias]", currentSite);
      }

      let sessionId = sessionStorage.getItem("CHECKOUT_CUSTOM_SESSION_ID");
      if (!sessionId) {
        sessionId = Date.now();
        sessionStorage.setItem("CHECKOUT_CUSTOM_SESSION_ID", sessionId);
      }

      const context = {
        curSite: localStorage.getItem("CURRENT_SITE") ?? null,
        customerId: window?.customer?.id,
        customerEmail: window?.customer?.email,
        isPartner: window?.customer?.isPartner,
      };

      console.log("customCheckout clicked", context);
      params.append("attributes[sessionID]", sessionId);
      params.append("attributes[context]", btoa(JSON.stringify(context)));
      params.append(
        "attributes[partyID]",
        localStorage.getItem("CURRENT_PARTY_ID")
      );

      const checkoutURL = `/checkout?${params.toString()}`;
      console.log("Redirecting to checkout:", checkoutURL);

      setTimeout(() => {
        window.location.href = checkoutURL;
      }, 500);
    });
  }

  async function initConfigureCustomCheckout() {
    const cart = await fetch("/cart.js")
      .then((res) => res.json())
      .catch((e) => console.log(e));
    configureCustomCheckout(cart);
  }

  // Make function globally accessible
  window.initConfigureCustomCheckout = initConfigureCustomCheckout;

  document.addEventListener("DOMContentLoaded", initConfigureCustomCheckout);

  async function getPartyWebAlias(partyId) {
    try {
      const response = await fetch(
        `https://ff-prd.api.sultans.co/dashboard/parties/${partyId}`,
        {
          method: "GET",
          headers: this.headers,
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch party info");
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error fetching party webAlias:", error);
      return null;
    }
  }

  // Add this function to handle banner updates
  function updateShoppingBarBanner() {
    const partyName = localStorage.getItem("CURRENT_PARTY_NAME");
    const partnerName = document.querySelector('[data-partner-name]')?.textContent;
    console.log("partyName", partyName);
    console.log("partnerName", partnerName);
    
    if (partyName && partyName !== "undefined") {
      const shoppingBarText = document.querySelector('.shopping-with-bar__text');
      if (shoppingBarText) {
        shoppingBarText.innerHTML = `You are shopping with <span class="shopping-with-bar__partner_name" data-partner-name>${partyName}</span>`;
      }
    } else if (partnerName && partnerName !== "undefined") {
      // Restore original partner name if no party
      const shoppingBarText = document.querySelector('.shopping-with-bar__text');
      if (shoppingBarText) {
        shoppingBarText.innerHTML = `You are shopping with <span class="shopping-with-bar__partner_name" data-partner-name>${partnerName}</span>`;
      }
    }
  }

  // Add storage event listener
  window.addEventListener('storage', (e) => {
    if (e.key === 'CURRENT_PARTY_NAME') {
      updateShoppingBarBanner();
    }
  });

  document.addEventListener("DOMContentLoaded", async () => {
    if (localStorage.getItem("CURRENT_PARTY_NAME")) {
      console.log("CURRENT_PARTY_NAME", localStorage.getItem("CURRENT_PARTY_NAME"));
      updateShoppingBarBanner();
    }
  });

  // Also update the banner when party is initially set
  document.addEventListener("DOMContentLoaded", async () => {
    console.log("DOMContentLoaded party");
    const urlParams = new URLSearchParams(window.location.search);
    const partyId = urlParams.get("party");

    if (partyId) {
      const response = await getPartyWebAlias(partyId);

      if (response && response.site && response.closed === false) {
        localStorage.setItem("CURRENT_PARTY_ID", partyId);
        if (response.partyName) {
          localStorage.setItem("CURRENT_PARTY_NAME", response.partyName); // Store the party name
        }
        const newUrl = new URL(window.location.href);
        newUrl.searchParams.set("pws", response.site);
        localStorage.setItem("CURRENT_SITE", response.site);

        const partner = await window.backend.getPartnerBySite(
          response.site, false
        );

        document.dispatchEvent(
          new CustomEvent("theme:partner:update", { detail: { partner } })
        );

        // Update the banner after partner info is set
        setTimeout(updateShoppingBarBanner, 100);

        window.history.replaceState({}, "", newUrl);
      } else {
        localStorage.removeItem("CURRENT_PARTY_ID");
        localStorage.removeItem("CURRENT_PARTY_NAME");
        updateShoppingBarBanner(); // Restore original partner name
      }
    }
  });
})();
